module.exports = __webpack_public_path__ + "static/media/b1_author.99b2d7be.mp3";